import * as MessagesActionTypes from 'actiontypes/messages';
import { processMessages } from 'actions/app';
import MessagesService from 'services/MessagesService';

const service = new MessagesService();

const acceptRequested = () => ({ type: MessagesActionTypes.ACCEPT_REQUESTED });

const acceptSuccess = (invitationId: number, data: any) => ({
  type: MessagesActionTypes.ACCEPT_SUCCESS,
  payload: { ...data, id: invitationId },
});

const acceptFailure = (error: any) => ({
  type: MessagesActionTypes.ACCEPT_FAILURE,
  error: true,
  status: error.response && error.response.status,
});


/** ----------------------------------------------------------------------------
 * ACCEPT A REQUEST
 -----------------------------------------------------------------------------*/
export default function accept(invitationId: number) {
  return async (dispatch: Function) => {
    dispatch(acceptRequested());

    try {
      const { data } = await service.acceptInvitation(invitationId);
      dispatch(acceptSuccess(invitationId, data));
      const { messages } = data;
      if (messages) {
        dispatch(processMessages(messages));
      }
      return data;
    } catch (error) {
      dispatch(acceptFailure(error));
      return error;
    }
  };
}